var modules_648c7803 = {"container":"Thead_module_container__4c9d46d5"};
import "../../../assets/esm/components/Table/src/Thead~BDb0lei6.css";

export { modules_648c7803 as default };
//# sourceMappingURL=Thead.module.less.js.map
